import React from 'react';
import { InputCurrency } from './currency-input';
import { InputDatePicker } from './input-date';
import { InputFile } from './input-file';
import { InputNumber } from './input-number';
import { InputPassword } from './input-password';
import { InputSearch } from './input-search';
import { InputText } from './input-text';
import { InputProps } from './props';

const Input = ({ color = '#47516f', type, ...rest }: InputProps) => {
    const validateInputType = () => {
        switch (type) {
            case 'text':
            case 'email':
                return <InputText {...rest} />;

            case 'search':
                return <InputSearch {...rest} />;

            case 'password':
                return <InputPassword {...rest} />;

            case 'number':
                return <InputNumber {...rest} />;

            case 'date':
                return <InputDatePicker {...rest} />;

            case 'file':
                return <InputFile {...rest} />;

            case 'currency':
                return <InputCurrency {...rest} />;

            default:
                return <InputText {...rest} />;
        }
    };

    return validateInputType() || null;
};

export { Input };
